import * as Types from '../constants/actionTypes';
const defaultState = {
    isPending: false,
    trucksList: [],
    error: ''
}
export default (state = defaultState, action) => {
    switch (action.type) {
        /* Box Details States */
        case Types.TRUCK_DETAIL_SUCCESS:
            return {
                ...state,
                trucksList: action.payload
            }
        case Types.TRUCKS_ADDED_SUCCESS:
            state.trucksList.push(action.payload)
            return {
                ...state
            }
        case Types.TRUCK_DELETED_SUCCESS:
            const newList = state.trucksList.filter((trucks) => trucks.id !== action.payload )
            return {
                ...state,
                trucksList : newList,
                deletedStatus:action.payload
            }
        case Types.LIST_ALL_TRUCKS:
            return {
                ...state,
                allTrucks: action.allTrucks
            }
        case Types.TRUCK_ERROR:
            return {
                ...state,
                truckError: action.truckError
            }
        case Types.TRUCK_LIST_UPDATED_SUCCESS:
            const updateIndex = state.trucksList.findIndex((data) => { return  data.id === action.payload.id} );
            if(updateIndex> -1) {
            state.trucksList[action.updateIndex] = action.payload
            }
            return{
                ...state,
            }
        case Types.TRUCK_INFO_COUNT_SUCCESS:
            return Object.assign({}, state, { truckInfoCount: action.payload})
        default:
            return state
    }
}
